/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2025-08-14 14:58:08
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-08-14 16:08:18
 * @FilePath: \toolmap\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'leaflet/dist/leaflet.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import XLSX from 'xlsx'
Vue.config.productionTip = false
Vue.use(ElementUI);
// Vue.use(XLSX)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
